module.exports = __webpack_public_path__ + "static/assets/93bae0a6958c0ccf69bb027da8e98a9c.svg";